import { FC, ReactNode } from "react"
import React from "react"
import { createTheme, ThemeProvider } from "@mui/material"

import uSmileDarkTheme from "./theme/theme.dark"

const UsmileDarkThemeProvider: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <ThemeProvider theme={createTheme(uSmileDarkTheme)}>
      {children}
    </ThemeProvider>
  )
}

export default UsmileDarkThemeProvider
